/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, ViewChild, AfterViewInit } from '@angular/core';
import { AbstractGridInputCellEditorComponent } from './abstract-grid-input-cell-editor.component';
import { QuantityTypeDirective } from '@gh/core-type';

@Component({
  standalone: false,
  selector: 'gh-grid-quantity-cell-editor',
  templateUrl: 'grid-quantity-cell-editor.component.html',
  styleUrls: ['grid-input-cell-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridQuantityCellEditorComponent extends AbstractGridInputCellEditorComponent implements AfterViewInit {
  @ViewChild(QuantityTypeDirective, { static: false }) qtyTypeDir: QuantityTypeDirective;

  isFormatOnFocus: boolean = true;

  private firstChar?: string;

  ngAfterViewInit(): void {
    if (this.firstChar) {
      this.qtyTypeDir.onInput(this.firstChar);
    }
    super.ngAfterViewInit();
  }

  // we redefine setting of first character,
  // because for number input we want to have unmodified user input (possibly incomplete) on init.
  protected setFirstChar(char: string): void {
    this.firstChar = char;
    this.isFormatOnFocus = false;
  }
}
